// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_ms365adminconsent_tenantid3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenant ID`)
};

const en_us2_ms365adminconsent_tenantid3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenant ID`)
};

const de_de2_ms365adminconsent_tenantid3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandanten-ID`)
};

const en_ms365adminconsent_tenantid3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenant ID`)
};

const de_ms365adminconsent_tenantid3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandanten-ID`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const ms365adminconsent_tenantid3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ms365adminconsent_tenantid3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ms365adminconsent_tenantid3", locale)
	if (locale === "en-GB") return en_gb2_ms365adminconsent_tenantid3(inputs)
	if (locale === "en-US") return en_us2_ms365adminconsent_tenantid3(inputs)
	if (locale === "de-DE") return de_de2_ms365adminconsent_tenantid3(inputs)
	if (locale === "en") return en_ms365adminconsent_tenantid3(inputs)
	return de_ms365adminconsent_tenantid3(inputs)
};
export { ms365adminconsent_tenantid3 as "ms365AdminConsent.tenantId" }